'use strict';

/**
 * @ngdoc service
 * @name observatoireApp.TitresMiniersService
 * @description
 * # TitresMiniersService
 * Service pour la gestion des titres miniers
 */
angular
  .module('observatoireApp')
  .factory('TitresMiniersService', ['$http', TitresMiniersService]);

function TitresMiniersService($http) {
  var service = {
    getTitresMiniers: getTitresMiniers,
    getTitreMiniersById: getTitreMiniersById,
    searchTitresMiniers: searchTitresMiniers,
    getDocumentsByTitreMinier: getDocumentsByTitreMinier
  };
  
  return service;
  
  /**
   * Récupère tous les titres miniers
   */
  function getTitresMiniers() {
    return $http.get('/api/titres-miniers')
      .then(function(response) {
        return response.data;
      });
  }
  
  /**
   * Récupère un titre minier par son ID
   */
  function getTitreMiniersById(id) {
    return $http.get('/api/titres-miniers/' + id)
      .then(function(response) {
        return response.data;
      });
  }
  
  /**
   * Recherche des titres miniers selon des critères
   */
  function searchTitresMiniers(params) {
    return $http.get('/api/titres-miniers/search', { params: params })
      .then(function(response) {
        return response.data;
      });
  }
  
  /**
   * Récupère les documents associés à un titre minier
   */
  function getDocumentsByTitreMinier(titreMinierId) {
    return $http.get('/api/titres-miniers-documents/titre-minier/' + titreMinierId)
      .then(function(response) {
        return response.data;
      });
  }
}
